import script from "./ImportProfileDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportProfileDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./ImportProfileDetailView.vue?vue&type=style&index=0&id=426b93fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426b93fa"]])

export default __exports__